module.exports = __webpack_public_path__ + "img/logo - Copy.79c6483e.png";